<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Link } from 'carbon-components-svelte';

  import type { DataTableCell } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

  import PermissionDelayButton from '../../PermissionDelayButton.svelte';

  import type { Approval, EntitlementMetadata, EntitlementRow, FeedMetadata, OpenModalDetail } from '../entitlements-table-types';

  export let cell: DataTableCell,
    row: EntitlementRow,
    feedIdsRequiringApprovalSet: Set<string>,
    savedEntitlementIdsSet: Set<string>,
    approval: Approval,
    entitlementMetadata: EntitlementMetadata,
    serviceId: number,
    feedMetadata: FeedMetadata;

  const dispatch = createEventDispatcher<{
    'open-modal': OpenModalDetail;
  }>();

  const hasTruthyProperty = (value: FeedMetadata, property: string): boolean => Boolean(value?.[property]);
  const feedName = String(cell.value ?? '');

  $: isDelayed =
    hasTruthyProperty(feedMetadata, 'defaultPermissionDelayMinutes') ||
    hasTruthyProperty(feedMetadata, 'defaultPermissionDelayHours') ||
    hasTruthyProperty(feedMetadata, 'defaultPermissionDelayDays') ||
    hasTruthyProperty(feedMetadata, 'defaultPermissionDelayMonths');
  $: requiresApproval = Boolean(approval || (feedIdsRequiringApprovalSet.has(row.feedId) && savedEntitlementIdsSet.has(row.id)));
</script>

<div class="data-feed-name-cell">
  {#if requiresApproval}
    <Link
      on:click={() =>
        dispatch('open-modal', {
          name: 'editApproval',
          approval,
          entitlement: {
            entitlementId: row.id,
            feedId: row.feedId,
            serviceId,
            ...(row.permissionId ? { permissionId: row.permissionId } : {}),
          },
        })}
    >
      <div class="feed-name">
        {feedName}
      </div>
    </Link>
  {:else}
    <div class="feed-name">{feedName}</div>
  {/if}
  {#if isDelayed}
    <PermissionDelayButton
      feedMetadata={feedMetadata ?? {}}
      entitlementMetadata={entitlementMetadata ?? {}}
      entitlementId={row.id}
      {feedName}
      isEditable={savedEntitlementIdsSet.has(row.id)}
      on:open-modal
    />
  {/if}
</div>

<style>
  .data-feed-name-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .data-feed-name-cell :global(a) {
    cursor: pointer;
  }

  .feed-name {
    font-size: 0.8rem !important;
  }
</style>
